// extracted by mini-css-extract-plugin
module.exports = {"container":"logout_container__2CM_C","label":"logout_label__2X0WH","button":"logout_button__1xGc7"};